import { datadogRum } from '@datadog/browser-rum';
import { Environment } from 'environments/environment-base';
import { buildRumConfig } from './datadog-rum.config';

/**
 * Initialises Datadog RUM before Angular bootstraps.
 *
 * Must be called pre-bootstrap (from main.ts) so the SDK captures initial page load,
 * Web Vitals, and early errors — this is why init lives here as a plain function rather
 * than in an Angular service / APP_INITIALIZER, which would run too late.
 *
 * No-op when RUM is disabled for the environment (dev / ci / mock).
 */
export function initObservability(environment: Environment, version: string): void {
    if (!environment.useDatadogRum) {
        return;
    }

    datadogRum.init(buildRumConfig(environment, version));
}
